<template>
  <div class="track-list">
    <h1>トラックリスト</h1>
    <div class="track" v-for="track in tracks" :key="track.name">
      <p>
        {{ track.seq }}. {{ track.title }}
        <span v-if="track.addition">( {{ track.addition }} )</span>
      </p>
      <p class="description">原曲：{{ track.original }}</p>
    </div>
  </div>
</template>

<script>
import tracks from '@/assets/adeyaka/json/tracks.json';

export default {
  name: 'TrackList',
  data() {
    return {
      tracks: tracks,
    };
  },
};
</script>

<style lang="scss">
.track-list h1 {
  margin-bottom: 15px;
}
.track {
  margin-bottom: 20px;
  p {
    margin: 0;
  }
  span {
    font-size: 12px;
  }
  .description {
    font-size: 12px;
    margin-top: 5px;
    padding-left: 15px;
  }
}
</style>
